import { Pipe, PipeTransform} from '@angular/core';

@Pipe({ name: 'filterStyles' })
export class FilterStylesPipe implements PipeTransform {
  transform(styles: any[], args: String): any {
    if (!styles || !args) {
      return styles;
    }

    const searchTerm = args.toLowerCase();
    return styles.filter(style => style.name.toLowerCase().includes(searchTerm));
  }
}
